import './App.css';
import Header from './components/Header';
import { RefCurrentPage } from './hooks/NavigationHooks';
import AlignmentResultsPage from './pages/AlignmentResultsPage';
import MainToolInputPage from './pages/MainToolInputPage';
import * as con from "./Constants"
import AnnotationResultsPage from './pages/AnnotationResultsPage';
import DocsMethodsPage from './pages/DocsMethodsPage';
import DocsGettingStartedPage from './pages/DocsGettingStartedPage';
import DocsResourcesPage from './pages/DocsResourcesPage';
import BugReportPage from './pages/BugReportPage';
import { TourProvider } from '@reactour/tour';
import { useTour } from './hooks/TourHooks';
import { useEffect, useState } from 'react';
import { checkServer } from './store/apiActions';
import { setStoredValue } from './store/actions';
// import { setStoredValue } from './store/actions';

// Component that uses the tour
function AppContent() {
  // Current page
  const currentPage = RefCurrentPage();

  // Tour functionality
  const tour = useTour();

  // Analysis mode state - true for new analysis, false for historic results
  const [isNewAnalysisMode, setIsNewAnalysisMode] = useState(true);

  // Function to toggle between modes
  const handleModeToggle = () => {
    setIsNewAnalysisMode(!isNewAnalysisMode);
  };

  // DEBUG
  // setStoredValue(con.ANNOTATION_RESULT_STACK, [])

  // Checks server health
  useEffect(() => {
    checkServer()
  }, [])




  // Uses a function through switch to render
  const renderComponents = (page) => {
    
    switch (page) {
      case con.PAGE_ALIGNMENT_RESULTS:
        return <AlignmentResultsPage />
      case con.PAGE_ANNOTATION_RESULTS:
        return <AnnotationResultsPage />
      case con.PAGE_DOCS_METHODS:
        return <DocsMethodsPage />
      case con.PAGE_DOCS_GETTING_STARTED:
        return <DocsGettingStartedPage />
      case con.PAGE_DOCS_RESOURCES:
        return <DocsResourcesPage />
      case con.PAGE_BUG_REPORT:
        return <BugReportPage />
      default:

        // Tests for experimental
        setStoredValue(con.IS_EXPERIMENTAL, `${page}`.toUpperCase() === `/${process.env.REACT_APP_EXPERIMENTAL_CODE}`.toUpperCase())

        return <MainToolInputPage
          onModeToggle={setIsNewAnalysisMode}
          isNewAnalysisMode={isNewAnalysisMode}
        />
    }
  }

  return (
    <div className="App">
      <Header
        onStartTour={tour.startTour}
        onModeToggle={handleModeToggle}
        isNewAnalysisMode={isNewAnalysisMode}
        showModeToggle={currentPage === con.PAGE_HOME || currentPage === undefined}
      />
      <div className='body'>
        {renderComponents(currentPage)}
      </div>
    </div>
  );
}

// Tour configuration
const tourConfig = {
  steps: [], // Will be set by useTour hook
  styles: {
    popover: (base) => ({
      ...base,
      '--reactour-accent': 'var(--primary-color-1)',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(44, 86, 151, 0.1)',
      background: 'linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)',
      maxWidth: '380px',
      minWidth: '320px',
    }),
    maskArea: (base) => ({
      ...base,
      rx: 8,
      fill: 'rgba(44, 86, 151, 0.08)',
      stroke: 'var(--primary-color-1)',
      strokeWidth: 2,
      strokeDasharray: '5,5',
      animation: 'tour-highlight-pulse 2s ease-in-out infinite',
    }),
    badge: (base) => ({
      ...base,
      backgroundColor: 'var(--primary-color-1)',
      color: 'white',
      borderRadius: '50%',
      boxShadow: '0 4px 12px var(--primary-color-1-t)',
      border: '2px solid white',
    }),
    dot: (base, { current, disabled }) => ({
      ...base,
      width: current ? '12px' : '8px',
      height: current ? '12px' : '8px',
      backgroundColor: current ? 'var(--primary-color-1)' : disabled ? '#d9d9d9' : '#bfbfbf',
      border: current ? '2px solid var(--primary-color-1-t)' : 'none',
      boxShadow: current ? '0 0 0 4px var(--primary-color-1-t)' : 'none',
    }),
  },
  padding: { mask: [24, 40], popover: [20, 40] },
  scrollSmooth: true,
  showBadge: true,
  showCloseButton: true,
  showNavigation: true,
  showDots: true,
  className: 'tour-popover',
  maskClassName: 'tour-mask',
  highlightedMaskClassName: 'tour-mask--highlighted',
  onClickMask: ({ setIsOpen }) => setIsOpen(false),
};

// Main App component with TourProvider
function App() {
  return (
    <TourProvider {...tourConfig}>
      <AppContent />
    </TourProvider>
  );
}

export default App;
